import React from "react";
import PropTypes from "prop-types";

import {
  getClientName,
  getBundledClientLogoUrl,
  resolveClientLogoUrl,
} from "util/clientLogo/clientLogo";

// Renders the current client's logo, preferring the centrally hosted copy at
// s3://cmp.io/images/<clientName>.png and falling back to the public/images
// asset bundled with this app.
//
// The bundled asset is what renders on first paint and stays put unless the
// remote logo is confirmed to decode as an image, so a client with no logo in
// s3://cmp.io behaves exactly as it did before this was introduced.
class ClientLogo extends React.Component {
  constructor(props) {
    super(props);
    this.state = { remoteLogoSrc: null };
  }
  componentDidMount() {
    this.isMounted_ = true;
    this.loadClientLogo();
  }
  componentDidUpdate() {
    // Picks the logo up after a client switch, which rewrites conceptName.
    this.loadClientLogo();
  }
  componentWillUnmount() {
    this.isMounted_ = false;
  }
  loadClientLogo() {
    const clientName = getClientName();
    if (!clientName || clientName === this.probedClientName) return;
    this.probedClientName = clientName;
    resolveClientLogoUrl(clientName).then((url) => {
      // Ignore a response that lost the race with a client switch.
      if (url && this.isMounted_ && getClientName() === clientName) {
        this.setState({ remoteLogoSrc: url });
      }
    });
  }
  render() {
    const { className, style, alt } = this.props;
    const src = this.state.remoteLogoSrc || getBundledClientLogoUrl();
    if (!src) return null;
    return <img src={src} alt={alt} className={className} style={style} />;
  }
}

ClientLogo.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

ClientLogo.defaultProps = {
  alt: "Client logo",
  className: "img-responsive",
  style: { maxHeight: 100 },
};

export default ClientLogo;



// WEBPACK FOOTER //
// ./src/components/ClientLogo/ClientLogo.jsx